import { ApiError, ApiParameter } from "@insite/client-framework/Services/ApiService";

export interface apiResultModel {
    result: any;
}

export interface ReportParameter extends ApiParameter {
    searchType?: string;
    searchValue?: string;
    fromDate?: string;
    toDate?: string;
    outputformat?: string;
}

export const url = "/api/v2/report/purchasehistory";

export async function getReport(parameter: ReportParameter) {
    const { searchType, searchValue, fromDate, toDate, outputformat } = parameter;
    const response = await fetch(
        `${url}?searchType=${searchType}&searchValue=${searchValue}&fromDate=${fromDate}&toDate=${toDate}&outputformat=${outputformat}`,
    );

    try {
        const blob = response.ok && (await response.blob());
        if (!response.ok) {
            throw new Error(
                JSON.stringify({
                    status: response.status,
                    errorJson: {
                        message: response.statusText,
                    },
                }),
            );
        }
        return blob;
    } catch (error) {
        let message: string;
        let errorJson: any;
        if (response.headers.get("Content-Type")?.startsWith("application/json")) {
            errorJson = (await response.json()) as { message: string; exceptionMessage?: string };
            message = errorJson.exceptionMessage ?? errorJson.message;
        } else {
            message = await response.text();
        }
        throw new ApiError(`${url}${parameter.outputformat}`, response, message, errorJson);
    }
}
